/*const variable for Restservice calls - key table values */
// placeholder datetime with day of week fields - german date format
export const GERMAN_DATE_TIME_WITH_DAYOFWEEK_PIPE_FORMAT = 'EEEE, dd.MM.yyyy HH:mm';
// placeholder datetime with day of week fields - english date format
export const ENGLISH_DATE_TIME_WITH_DAYOFWEEK_PIPE_FORMAT = 'EEEE, MM/dd/yyyy hh:mm a';

// placeholder datetime - german date format
export const GERMAN_DATE_TIME_PIPE_FORMAT = 'dd.MM.yyyy HH:mm';
// placeholder datetime - english date format
export const ENGLISH_DATE_TIME_PIPE_FORMAT = 'MM/dd/yyyy hh:mm a';

// placeholder datetime - german date format
export const GERMAN_DATE_TIME_FORMAT_PLACEHOLDER = 'tt.mm.jjjj hh:mm';
// placeholder datetime - english date format
export const ENGLISH_DATE_TIME_FORMAT_PLACEHOLDER = 'mm/dd/yyyy hh:mm';
